import React from "react";
import Styles from "./ViewInjectDrawal.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
const ViewInjectDrawal = ({
  data,
  open,
  handleClose,
  termsDocumentId,
  onViewDocument,
}) => {
  if (!data) return null;

  const listing = Array.isArray(data) ? data[0] : data;
  if (!listing) return null;

  let displayData;

  if (listing.bankingListing || listing.againstBankingListing) {
    displayData =
      listing.source === "RECEIVED"
        ? listing.bankingListing
        : listing.againstBankingListing;
  } else {
    displayData = listing;
  }

  const maxLength = Math.max(
    displayData?.bankingSlotInjects?.length || 0,
    displayData?.bankingSlotDrawls?.length || 0
  );

  const formatTime = (time) => {
    if (!time) return "—";
    return time === "23:59" ? "24:00" : time;
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.createEditModalCont}`}>
        <div className={`display_flex_row modalHeading ${Styles.modalHeading}`}>
          <div className={Styles.headingText}>
            {listing.bankingListing || listing.againstBankingListing
              ? `Requisition List - ${displayData.name}`
              : `Requisition List - ${displayData.name}`}
          </div>
          <Close
            style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>

        <div className={Styles.indentListint}>
          {/* <div className={Styles.indentTableHeader}>
            <div className={Styles.headerIntent}>
              <div className="display_flex_row_gap_4">
                <span
                  style={{
                    textAlign: "left",
                    width: "100%",
                    color: "var(--fifth-color-text",
                    fontWeight: 400,
                  }}
                >
                  Listing Id
                </span>
                <span style={{ width: "100%", fontWeight: "400" }}>
                  {displayData?.name || "N/A"}
                </span>
              </div>
              
              {(listing.bankingListing || listing.againstBankingListing) && (
                <div className="display_flex_row_gap_4">
                  <span className={Styles.titleCont}>Connection Status:</span>
                  <span
                    style={{
                      width: "56%",
                      color: "var(--secondary-color-text",
                    }}
                  >
                    {listing.status}
                  </span>
                </div>
              )}
              
              {(listing.bankingListing || listing.againstBankingListing) && (
                <div className="display_flex_row_gap_4">
                  <span className={Styles.titleCont}>Company:</span>
                  <span
                    style={{
                      width: "56%",
                      color: "var(--secondary-color-text",
                    }}
                  >
                    {displayData?.companyName || "N/A"}
                  </span>
                </div>
              )}
              <div className="display_flex_row_gap_4">
                <span className={Styles.titleCont}>Settlement Rate:</span>{" "}
                <span
                  style={{ width: "56%", color: "var(--secondary-color-text" }}
                >
                  {" "}
                  {displayData?.settlementRate || "N/A"}(₹/kWh)
                </span>
              </div>
              <div className="display_flex_row_gap_4">
                <span className={Styles.titleCont}>Banking Factor:</span>{" "}
                <span
                  style={{ width: "50%", color: "var(--secondary-color-text" }}
                >
                  {displayData?.bankingFactor || "N/A"}(%)
                </span>
              </div>
              <div className="display_flex_row_gap_4">
                <span className={Styles.titleCont}>T&C</span>
                <div
                  style={{
                    color: "var(--primary-color-text)",
                    cursor: termsDocumentId ? "pointer" : "default",
                    opacity: termsDocumentId ? 1 : 0.6,
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (termsDocumentId && onViewDocument) {
                      onViewDocument(termsDocumentId);
                    }
                  }}
                  title={
                    termsDocumentId
                      ? "View Terms & Conditions"
                      : "No T&C document available"
                  }
                >
                  View
                </div>
              </div>
              <div className="display_flex_row_gap_4">
                <span className={Styles.titleCont}>Profile</span>
                <div style={{ color: "var(--primary-color-text)" }}>View</div>
              </div>
            </div>
            <div>
              Comments:{" "}
              <span style={{ textTransform: "capitalize" }}>
                {displayData?.comments || "N/A"}
              </span>
            </div>
          </div> */}
          <div className={Styles.injectSideTable}>
            <div className={Styles.tableHeaderInject}>
              <div>Injection Range</div>
              <div>Injection Quantity</div>
            </div>
            <div className={Styles.searchTableSection}>
              {maxLength === 0 ? (
                <div
                  style={{
                    padding: "20px",
                    textAlign: "center",
                    color: "#777",
                    fontStyle: "italic",
                  }}
                >
                  No injection/withdrawal details available
                </div>
              ) : (
                [...Array(maxLength)].map((_, idx) => {
                  const injectItem =
                    displayData?.bankingSlotInjects?.[idx] || {};
                  const drawalItem =
                    displayData?.bankingSlotDrawls?.[idx] || {};
                  return (
                    <div className={Styles.tableInjectData}>
                      <div>
                        <span>
                          {injectItem.dateStartAt && injectItem.dateEndAt
                            ? `${injectItem.dateStartAt} to ${injectItem.dateEndAt}`
                            : injectItem.dateStartAt
                            ? injectItem.dateStartAt
                            : injectItem.dateEndAt
                            ? injectItem.dateEndAt
                            : "—"}
                        </span>
                        <span>
                          {injectItem.slotStartAt && injectItem.slotEndAt
                            ? `${injectItem.slotStartAt} to ${formatTime(
                                injectItem.slotEndAt
                              )}`
                            : injectItem.slotStartAt
                            ? injectItem.slotStartAt
                            : injectItem.slotEndAt
                            ? formatTime(injectItem.slotEndAt)
                            : "—"}
                        </span>
                      </div>
                      <div>
                        {injectItem.requiredQty != null
                          ? `${injectItem.requiredQty} MW`
                          : "—"}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
          <div className={Styles.drawalSideTable}>
            <div className={Styles.tableHeaderInject}>
              <div>Drawal Range</div>
              <div>Drawal Quantity</div>
            </div>
            <div className={Styles.searchTableSection}>
              {maxLength === 0 ? (
                <div
                  style={{
                    padding: "20px",
                    textAlign: "center",
                    color: "#777",
                    fontStyle: "italic",
                  }}
                >
                  No injection/withdrawal details available
                </div>
              ) : (
                [...Array(maxLength)].map((_, idx) => {
                  const injectItem =
                    displayData?.bankingSlotInjects?.[idx] || {};
                  const drawalItem =
                    displayData?.bankingSlotDrawls?.[idx] || {};
                  return (
                    <div className={Styles.tableDrawalData}>
                      <div>
                        <span>
                          {drawalItem.dateStartAt && drawalItem.dateEndAt
                            ? `${drawalItem.dateStartAt} to ${drawalItem.dateEndAt}`
                            : drawalItem.dateStartAt
                            ? drawalItem.dateStartAt
                            : drawalItem.dateEndAt
                            ? drawalItem.dateEndAt
                            : "—"}
                        </span>

                        <span>
                          {drawalItem.slotStartAt && drawalItem.slotEndAt
                            ? `${drawalItem.slotStartAt} to ${formatTime(
                                drawalItem.slotEndAt
                              )}`
                            : drawalItem.slotStartAt
                            ? drawalItem.slotStartAt
                            : drawalItem.slotEndAt
                            ? formatTime(drawalItem.slotEndAt)
                            : "—"}
                        </span>
                      </div>
                      <div>
                        {drawalItem.requiredQty != null
                          ? `${drawalItem.requiredQty} MW`
                          : "—"}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
        <div className={Styles.commentsSection}>
          <span className="scroll_bar_y">
            Comments
            <span style={{ textTransform: "capitalize" }}>
              {displayData?.comments || "N/A"}
            </span>
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default ViewInjectDrawal;
